import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Wrapper } from './Tutorial.styles';

export class TutorialButton extends Component {
  render() {
    return (
      <Wrapper id={this.props.id}>
        <Button variant="contained" color="primary" size="small" mini={true}>
          {this.props.text}&nbsp;&nbsp;
          <ArrowForwardIcon style={{ fontSize: 16 }} />
        </Button>
      </Wrapper>
    );
  }
}
